import { type FC, type PropsWithChildren, createContext, useContext, useMemo, useState } from "react";

export interface FlyerDetailsContext {
    isZoomed: boolean;
    setIsZoomed: React.Dispatch<React.SetStateAction<boolean>>;
}

const FlyerDetailsContext = createContext<FlyerDetailsContext>(null);

export const useFlyerDetailsContext = () => {
    const context = useContext(FlyerDetailsContext);
    if (context === null) {
        throw new Error("useFlyerDetailsContext must be used within a FlyerDetailsContextProvider");
    }
    return context;
};

export const FlyerDetailsContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [isZoomed, setIsZoomed] = useState<boolean>(false);

    const context = useMemo<FlyerDetailsContext>(
        () => ({
            isZoomed,
            setIsZoomed,
        }),
        [isZoomed],
    );

    return <FlyerDetailsContext.Provider value={context} children={children} />;
};

FlyerDetailsContextProvider.displayName = "FlyerDetailsContextProvider";
